import jump from 'jump.js';

class FooterScrollToTop {
	button: HTMLElement = FooterScrollToTop.getElementById('js-FooterScrollToTopClick');
	rocket: HTMLElement = FooterScrollToTop.getElementById('js-FooterScrollToTopAnimate');

	private static getElementById(elementId: string): HTMLElement {
		const element = document.getElementById(elementId);
		if (!element) {
			throw new Error(`element with id '${elementId}' was not found`);
		}
		return element;
	}

	init(): void {
		if (!matchMedia('(hover: none)').matches) {
			this.button.classList.add('canHover');
		}
		this.button.addEventListener('click', () => this.scrollUp());
	}

	private scrollUp(): void {
		const { height } = document.body.getBoundingClientRect();
		const duration = Math.log(1 + height / 1000) * 650;
		const { top, left } = this.rocket.getBoundingClientRect();

		this.button.classList.add('FooterRocketLaunch');
		this.rocket.style.position = 'fixed';
		this.rocket.style.top = `${top}px`;
		this.rocket.style.left = `${left}px`;

		let rocketTop = top;
		const step = Math.max(Math.log(duration / top) / 10, 0.1);

		const timeout = setInterval(() => (this.rocket.style.top = `${(rocketTop -= step)}px`), 1);

		jump(document.body, {
			duration,
			callback: () => {
				clearInterval(timeout);
				this.button.classList.remove('FooterRocketLaunch');
				this.rocket.removeAttribute('style');
			}
		});
	}
}

document.addEventListener('DOMContentLoaded', () => {
	new FooterScrollToTop().init();
});
